import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/c2UfVnLDz8HoaG7Sf6Whg4/bono_1_yoga.webp',
    name: 'Routine di Apertura',
    desc: 'Aprire ogni lezione con presenza e calma.',
    value: '€ 19'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/2Wf8fWH4ktrA3hAEuYjvJ3/bono_2_yoga.webp',
    name: '21 Intuizioni Profonde',
    desc: 'Frasi e riflessioni da condividere in aula.',
    value: '€ 27'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8SBCF1LoqgHBn5rcoFmjyn/bono_3_yoga.webp',
    name: 'Il Manuale delle Transizioni Fluide',
    desc: 'Collegare le posizioni senza intoppi.',
    value: '€ 37'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/vZHJXtd2zgetPiHDJre3DZ/bono_4_yoga.webp',
    name: "L'Arte della Voce",
    desc: 'Guidare con una voce che ispira fiducia.',
    value: '€ 19'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/kxVRE7Xx7dKfhoEynLeD9H/bono_5_yoga.webp',
    name: '20 Sequenze Illustrate',
    desc: "Pronte da seguire a colpo d'occhio.",
    value: '€ 27'
  }];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <div className="text-center mb-12" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-28">
            🎁 5 Bonus Esclusivi
          </h2>
          <p className="text-brand-gray" data-id="element-29">
            Valore totale di{' '}
            <span className="font-bold text-brand-terracotta line-through" data-id="element-30">
              € 129
            </span>{' '}
            — Inclusi <strong className="text-brand-text" data-id="element-31">GRATIS</strong>
          </p>
        </div>

        <div className="space-y-4" data-id="element-32">
          {bonuses.map((bonus, index) => <div key={bonus.name} className="bg-white rounded-2xl p-4 md:p-6 flex items-center gap-4 md:gap-6 shadow-sm border border-brand-creamDark/50" data-id="element-33">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-green text-white flex items-center justify-center font-bold shrink-0 text-sm md:text-base" data-id="element-34">
                {index + 1}
              </div>

              <img src={bonus.image} alt={bonus.name} className="w-14 h-14 md:w-20 md:h-20 rounded-xl shrink-0 object-cover border border-brand-creamDark" data-id="element-35" />

              <div className="flex-1 min-w-0" data-id="element-36">
                <h3 className="font-bold text-brand-text text-sm md:text-base mb-1" data-id="element-37">
                  {bonus.name}
                </h3>
                <p className="text-brand-gray text-xs md:text-sm mb-2" data-id="element-38">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-39">
                  <span className="text-brand-terracotta line-through font-medium" data-id="element-40">
                    {bonus.value}
                  </span>
                  <span className="text-brand-green font-bold" data-id="element-41">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}